export default __webpack_public_path__ + "static/spinner-0e025e1e78d618a86410c8e7ee509ef0.gif";